<script lang="ts">
    import src from './Icons/svg/add_FILL0_wght400_GRAD0_opsz24.svg';
    import WhiteColor from './WhiteColor.svelte';

    export let disabled: boolean = false;
    export let showIcon: boolean = true;
</script>

<button class="btn-main dont-break" class:showIcon on:click {disabled}>
    <span
        style="filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(152deg) brightness(103%) contrast(103%); width:24px; height: 24px;"
    >
        <img {src} alt="Add" class:showIcon />
    </span>
</button>

<style>
    .btn-main {
        background-color: #1c5dc7;
        color: white;
        border: none;
        cursor: pointer;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        line-height: 14px;
    }
    .btn-main img {
        height: 23px;
        width: 23px;
    }
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
